import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import toast from '../services/toast';
import './Auth.css';

export default function EsqueciSenha() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [ultimos4, setUltimos4] = useState('');
  const [recoveryToken, setRecoveryToken] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [concluido, setConcluido] = useState(false);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleVerificar(e) {
    e.preventDefault();
    setErro('');
    if (ultimos4.length !== 4 || !/^\d{4}$/.test(ultimos4)) {
      return setErro('Informe exatamente 4 números do WhatsApp.');
    }
    setLoading(true);
    try {
      const data = await api.post('/auth/verificar-recuperacao', { email, ultimos4 });
      setRecoveryToken(data.recoveryToken);
      setStep(2);
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleRedefinir(e) {
    e.preventDefault();
    setErro('');
    if (novaSenha !== confirmar) return setErro('As senhas não conferem.');
    if (novaSenha.length < 6) return setErro('A senha deve ter pelo menos 6 caracteres.');
    setLoading(true);
    try {
      await api.post('/auth/redefinir-senha', { recoveryToken, novaSenha });
      setConcluido(true);
      toast.success('Senha alterada com sucesso!');
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">🔑</div>
        <h1 className="auth-title">Recuperar Senha</h1>

        {concluido ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: 'var(--text2)', marginBottom: 24, lineHeight: 1.6 }}>
              Senha alterada com sucesso.<br />Faça login para continuar.
            </p>
            <Link to="/login" className="btn btn-primary btn-block" style={{ display: 'block', textDecoration: 'none', padding: '12px' }}>
              Ir para o Login
            </Link>
          </div>
        ) : step === 1 ? (
          <>
            <p className="auth-sub">Informe seus dados para verificação</p>
            {erro && <div className="alert alert-error">{erro}</div>}
            <form onSubmit={handleVerificar}>
              <div className="form-group">
                <label>E-mail cadastrado</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="seu@email.com" />
              </div>
              <div className="form-group">
                <label>Últimos 4 números do WhatsApp</label>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={4}
                  value={ultimos4}
                  onChange={e => setUltimos4(e.target.value.replace(/\D/g, '').slice(0, 4))}
                  required
                  placeholder="ex: 4456"
                />
                <span className="form-hint">Digite apenas os 4 últimos números do WhatsApp cadastrado em sua conta.</span>
              </div>
              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                {loading ? 'Verificando...' : 'Verificar'}
              </button>
            </form>
          </>
        ) : (
          <>
            <p className="auth-sub">Crie uma nova senha</p>
            {erro && <div className="alert alert-error">{erro}</div>}
            <form onSubmit={handleRedefinir}>
              <div className="form-group">
                <label>Nova senha</label>
                <input type="password" value={novaSenha} onChange={e => setNovaSenha(e.target.value)} required placeholder="••••••••" />
              </div>
              <div className="form-group">
                <label>Confirmar nova senha</label>
                <input type="password" value={confirmar} onChange={e => setConfirmar(e.target.value)} required placeholder="••••••••" />
              </div>
              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                {loading ? 'Salvando...' : 'Salvar Nova Senha'}
              </button>
            </form>
          </>
        )}

        <p className="auth-footer"><Link to="/login">Voltar ao Login</Link></p>
      </div>
    </div>
  );
}
